<template>
  <div class="serviceSupport">
    <div class="screen">
      <!-- <router-link :to="{ path: '/apply/GoodsGroup/4/createGroup' }"> -->
      <el-button type="primary" size="small" @click="dialogVisible = true">添加服务项</el-button>
      <!-- </router-link> -->
    </div>
    <template>
      <div class="tables">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="#" width="40"></el-table-column>
            <el-table-column prop="name" label="服务项" min-width="140"></el-table-column>
            <el-table-column prop="name" label="排序" min-width="140"></el-table-column>
            <el-table-column prop="name" label="操作" min-width="140"></el-table-column>
          </el-table>
        </template>
      </div>
    </template>
    <el-dialog
      title="添加服务"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <el-form label-position="right" label-width="80px" :model="formLabelAlign">
        <el-form-item label="服务名称">
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="formLabelAlign.region" placeholder="默认100"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="success" class="success">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLabelAlign: {
          name: '',
          region: 100,
          type: ''
        },
      dialogVisible: false,
      activeName: "1",
      tableData: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.serviceSupport {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .el-select {
    width: 100px;
  }
  .screen {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 25px;
    .el-button,
    .el-select,
    .el-input {
      margin-right: 10px;
    }
    .el-input {
      width: 200px;
    }
  }
  .tables {
    width: 100%;
    border: 1px solid #ebeef5;
  }
  .success {
    width: 100%;
  }
}
</style>

<style lang="scss">
.serviceSupport {
  .cell {
    text-align: center;
  }
}
</style>
